import React, { useRef, useEffect, useCallback } from "react";
import SVGA from "svgaplayerweb";

const SVGAAnimation = ({ animationUrl }) => {
  const svgaRef = useRef(null);

  const SvgaPlayer = useCallback(() => {
    if (animationUrl && svgaRef.current) {
      const player = new SVGA.Player(svgaRef.current);
      const parser = new SVGA.Parser();

      parser.load(
        animationUrl,
        (videoItem) => {
          player.setVideoItem(videoItem);
          player.startAnimation();
        },
        (error) => {
          console.error("Failed to load SVGA file:", error);
        }
      );
    }
  }, [animationUrl]);

  useEffect(() => {
    if (animationUrl) {
      SvgaPlayer();
    }
  }, []);

  return <div ref={svgaRef} style={{ width: 200, height: 200 }}></div>;
};

export default SVGAAnimation;
